import { render, staticRenderFns } from "./CarouselView.vue?vue&type=template&id=397ba224&scoped=true"
import script from "./CarouselView.vue?vue&type=script&lang=js"
export * from "./CarouselView.vue?vue&type=script&lang=js"
import style0 from "./CarouselView.vue?vue&type=style&index=0&id=397ba224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ba224",
  null
  
)

export default component.exports